import Swal from 'sweetalert2';

const swal = Swal.mixin({
    confirmButtonColor: '#36802d',
    cancelButtonColor: '#6c757d',
    borderRadius: '8px',
    customClass: {
        popup: 'swal-popup',
    },
});

export default swal;
